export default __webpack_public_path__ + "static/media/icon-Table-Up-Chevron.2e0f4844.svg";